window.runtimeConfig = {
  AFP_URL: "https://airteam.cloud/",
  AFP_SERVER_URL: "https://afp.airteam.cloud",
  FFSOLAR_SERVER_URL: "https://editor.airteam.cloud",
  APP_ENV: "production",
};
